import { useState } from "react";
import "../../styles/accountOverview.css"

import { Filters } from "../components"
import { useSelector } from "react-redux";
import Overview from "./Overview";

function Header() {
    const { projectsUsage, filteredOverview } = useSelector((state) => state.projects)
    const filteredProjectUsage = filteredOverview.projectsUsage

    return (
        <div className={`account-overview flex`}>
            <div className={`filter-container ${!projectsUsage.sortedDates.length ? "":""} w-full min-w-[300px] xl:max-w-[300px]`}>
                <Filters></Filters>
            </div>
            <div className="w-full">
                <Overview projectsUsage={projectsUsage} filteredProjectsUsage={filteredProjectUsage} ></Overview>
            </div>
        </div>
    )
}

export default Header